module.exports = __webpack_public_path__ + "static/assetsInfo-6efb5e39701ece186c06d853bb89a950.svg";